export default input =>
  new Promise(resolve => {
    input.select()
    input.setSelectionRange(0, 99999)

    document.execCommand("copy")
    resolve()
  })
